var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"component_body"},[(_vm.typeLoading)?_c('div',{staticClass:"_statixtcs"},_vm._l((_vm.userModule),function(item){return _c('div',{key:item},[(_vm.userModule.includes(item))?_c('div',{staticStyle:{"width":"40vw","height":"500px"},attrs:{"id":item}}):_vm._e()])}),0):_c('div',[_c('Loading')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }